import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";

export class CBox extends BasicCPCLArg<CBox> {
  private lineWidth: number;
  private topLeftX: number;
  private topLeftY: number;
  private bottomRightX: number;
  private bottomRightY: number;

  constructor(options?: {
    /**
     * 边框线条宽度
     */
    lineWidth?: number
    /**
     * 矩形框左上角x坐标
     */
    topLeftX?: number
    /**
     * 矩形框左上角y坐标
     */
    topLeftY?: number
    /**
     * 矩形框右下角x坐标
     */
    bottomRightX?: number
    /**
     * 矩形框右下角y坐标
     */
    bottomRightY?: number
  }) {
    super();
    this.lineWidth = options?.lineWidth ?? 0;
    this.topLeftX = options?.topLeftX ?? 0;
    this.topLeftY = options?.topLeftY ?? 0;
    this.bottomRightX = options?.bottomRightX ?? 0;
    this.bottomRightY = options?.bottomRightY ?? 0;

  }

  clause(): CommandClause {
    if (this.topLeftX > 575) {
      this.topLeftX = 575;
    }
    if (this.bottomRightX > 575) {
      this.bottomRightX = 575;
    }
    return CPCLCommand.with(this.header())
      .appendNumber(this.topLeftX)
      .appendNumber(this.topLeftY)
      .appendNumber(this.bottomRightX)
      .appendNumber(this.bottomRightY)
      .appendNumber(this.lineWidth)
      .clause();
  }

  header(): string {
    return 'BOX';
  }
}



